/* 🤖 this file was generated by svg-to-ts */
export const DfIconBookmark16: {
  name: 'bookmark-16';
  data: string;
} = {
  name: 'bookmark-16',
  data: `<svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><path d="M13 2v13.003a1 1 0 0 1-1.682.731l-2.733-2.549a1 1 0 0 0-1.213.041l-2.69 2.509A1 1 0 0 1 3 15.003V2a2 2 0 0 1 2-2h6a2 2 0 0 1 2 2z"/></svg>`
};
